export const defaultBackgroundColor = '#BDBDBD';
export function pickColorForName(inputName: string): string {
  if (!inputName) {
    return defaultBackgroundColor;
  }

  let nameSum = 0;
  const COLOR_CODES = [
    '#516573',
    '#5E9FE0',
    '#79B992',
    '#FFA726',
    '#9575CD',
    '#FFBD4D',
    '#D45D8C',
    '#4D968D',
    '#FF7B57',
  ];
  for (let i = 0; i < inputName.length; i++) {
    nameSum += inputName[i].charCodeAt(0);
  }
  const index = nameSum % COLOR_CODES.length;
  return COLOR_CODES[index];
}
